document.addEventListener("DOMContentLoaded", function () {


  //=> ROUNDED FRAME SPACER

  document.querySelectorAll('.is-style-rounded-frame').forEach(el => {
    const spacer = document.createElement('div');
    spacer.className = 'roundedframe-spacer';
    el.parentNode.insertBefore(spacer, el);
  });



  // => STICKY HEADER : HEADROOM STYLE

  var myElement = document.querySelector("#main-header");
  // construct an instance of Headroom, passing the element
  var headroom = new Headroom(myElement);
  // initialise
  headroom.init();


  // => RESPONSIVE MENU and trigger
  // => TRIGGER RESPONSIVE MENU


  const $respMenu = $("#df-rm");
  const $mainHeader = $("#main-header");
  const $respMenuTrigger = $(".rm-trigger-wrapper");
  $(".rm-trigger-wrapper").click(function () {
  });

  $respMenuTrigger.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#nav-icon3").toggleClass("open");
    $respMenu.toggleClass("active");
    $mainHeader.toggleClass("active");
  });

  $respMenu.on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function () {
    $respMenu.removeClass("active");
    $mainHeader.removeClass("active");
    $("#nav-icon3").removeClass("open");
  });


  // => Header : CREATE A CLASS ON CLICK : le tout étant lié à aria-expanded du button qui ouvre le sub-menu

  const toggles = document.querySelectorAll('.wp-block-navigation-submenu__toggle');

  toggles.forEach(button => {
    const parentLi = button.closest('li');

    const observer = new MutationObserver(() => {
      if (button.getAttribute('aria-expanded') === 'true') {
        button.classList.add('is-open');
        parentLi?.classList.add('child-is-open');
      } else {
        button.classList.remove('is-open');
        parentLi?.classList.remove('child-is-open');
      }
    });

    observer.observe(button, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  });


  // => CREER UN LIEN SUR LES POSTS DE LA POSTS GRID (réalisations)
  document.querySelectorAll('.is-style-posts-swiper li.wp-block-post, .is-style-posts-grid-3-col li.wp-block-post, .is-style-posts-grid-2-col li.wp-block-post').forEach(post => {
    const link = post.querySelector('.wp-block-post-title a')?.href;

    if (!link) return;

    post.style.cursor = 'pointer';
    post.addEventListener('click', (e) => {
      // Évite le double-déclenchement si on clique directement sur le lien titre
      if (e.target.closest('a')) return;
      window.location.href = link;
    });
  });
  document.querySelectorAll('.is-style-df-rounded-block-a').forEach(post => {
    const link = post.querySelector('.wp-block-button__link')?.href;

    if (!link) return;

    post.style.cursor = 'pointer';
    post.addEventListener('click', (e) => {
      // Évite le double-déclenchement si on clique directement sur le lien titre
      if (e.target.closest('a')) return;
      window.location.href = link;
    });
  });






  $(document).ready(function () {
    // => SWIPER AVIS
    if ($(".is-style-swiper-avis").length > 0) {
      $(".is-style-swiper-avis").each(function (index, element) {
        var el = $(element);
        el.addClass("swiper");
        var wrapper = $("<div/>").addClass("swiper-wrapper");
        el.find(">.wp-block-group ").addClass("swiper-slide");
        el.find(">.wp-block-group ").appendTo(wrapper);
        wrapper.appendTo(el);
        el.append(
          $("<div/>")
            .addClass("avis-controls")
            .append(
              $("<div/>")
                .addClass("cs-slider-btn slider-btn-prev image-slider-btn-prev")
                .html('<div class="inner-content"></div>'),
            )
            .append($("<div/>").addClass("swiper-pagination avis-pagination"))
            .append(
              $("<div/>")
                .addClass("cs-slider-btn slider-btn-next image-slider-btn-next")
                .html('<div class="inner-content"></div>'),
            ),
        );
      });
      const swiperAvis = new Swiper(".is-style-swiper-avis", {
        allowTouchMove: true,
        simulateTouch: true,
        speed: 500,
        spaceBetween: 100,
        slidesPerView: 1,
        breakpoints: {
          1025: {
            slidesPerView: 1,
            spaceBetween: 100,
          },
          769: {
            slidesPerView: 1,
            spaceBetween: 100,
          },
        },
        navigation: {
          nextEl: ".image-slider-btn-next",
          prevEl: ".image-slider-btn-prev",
        },
        pagination: {
          el: ".avis-pagination",
          clickable: true,
        },
      });
    }

    // => SWIPER REAL
    if ($(".is-style-posts-swiper").length > 0) {
      $(".is-style-posts-swiper").each(function (index, element) {
        var el = $(element);
        el.addClass("swiper");
        var wrapper = $("<div/>").addClass("swiper-wrapper");
        el.find(">.wp-block-post ").addClass("swiper-slide");
        el.find(">.wp-block-post ").appendTo(wrapper);
        wrapper.appendTo(el);
        el.append(
          $("<div/>")
            .addClass("abs-cs-btn cs-slider-btn slider-btn-prev image-slider-btn-prev hide-m")
            .html('<div class="inner-content"></div>'),
        )
          .append(
            $("<div/>")
              .addClass("abs-cs-btn cs-slider-btn slider-btn-next image-slider-btn-next hide-m")
              .html('<div class="inner-content"></div>'),
          )

          .append(
            $("<div/>")
              .addClass("avis-controls")
              .append(
                $("<div/>")
                  .addClass("cs-slider-btn slider-btn-prev image-slider-btn-prev hide-dk block-m")
                  .html('<div class="inner-content"></div>'),
              )
              .append($("<div/>").addClass("swiper-pagination avis-pagination"))
              .append(
                $("<div/>")
                  .addClass(
                    "cs-slider-btn slider-btn-next image-slider-btn-next hide-dk block-m",
                  )
                  .html('<div class="inner-content"></div>'),
              ),
          );
      });
      new Swiper(".is-style-posts-swiper", {
        allowTouchMove: true,
        simulateTouch: true,
        speed: 500,
        spaceBetween: 10,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
          1025: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10,
          },
          769: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".image-slider-btn-next",
          prevEl: ".image-slider-btn-prev",
        },
        pagination: {
          el: ".avis-pagination",
          clickable: true,
        },
      });
    }
    if ($(".is-style-img-swiper").length > 0) {
      $(".is-style-img-swiper").each(function (index, element) {
        var $el = $(element);
        $el.addClass("swiper");

        var $wrapper = $("<div/>").addClass("swiper-wrapper");
        var $slides = $el.find(">.wp-block-image").addClass("swiper-slide");

        // Meh but it works...
        if ($slides.length < 10) {
          $slides.clone().appendTo($wrapper);
        }
        $slides.appendTo($wrapper);

        $wrapper.appendTo($el);

        new Swiper(element, {
          allowTouchMove: true,
          simulateTouch: true,
          speed: 500,
          spaceBetween: 12,
          slidesPerView: 3,
          slidesPerGroup: 1,
          loop: true,
          loopAdditionalSlides: 5,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          breakpoints: {
            769: {
              slidesPerView: 5,
              slidesPerGroup: 1,
            },
          }
        });
      });
    }

    function checkScroll() {
      if ($(window).scrollTop() > 80) {
        $("body").addClass("scrolled");

        if (!$("#go-to-top").length) {
          var goToTopButton = $("<button/>", {
            id: "go-to-top",
            click: function () {
              $("html, body").animate({ scrollTop: 0 }, 500);
            },
          });

          $("body").append(goToTopButton);

          $(window).on("scroll", function () {
            if ($(window).scrollTop() > 200) {
              $("#go-to-top").fadeIn();
            } else {
              $("#go-to-top").fadeOut();
            }
          });
        }
      } else {
        $("body").removeClass("scrolled");

        if ($("#go-to-top").length) {
          $("#go-to-top").remove();
        }
      }
    }

    $(window).on("scroll", checkScroll);
    checkScroll();

    // Smooth scroll for anchor links
    $("a[href^='#']:not(.menu-item-text)").on("click", function (e) {
      e.preventDefault();

      var target = $(this.getAttribute("href"));

      $("html, body").animate(
        {
          scrollTop: target.offset().top - 100,
        },
        1000,
      ); // 1000ms = 1 second of animation
    });

    document
      .querySelectorAll(".wsi-current-year")
      .forEach((n) => (n.textContent = new Date().getFullYear()));


  });


  // * Ajout du span dans tous les boutons gradient
  document.querySelectorAll('a.has-orange-gradient-gradient-background').forEach(btn => {
    const span = document.createElement('span')
    span.style.cssText = 'position: relative; z-index: 1;'
    span.innerHTML = btn.innerHTML
    btn.innerHTML = ''
    btn.appendChild(span)
  })



});




